module.exports = __webpack_public_path__ + "img/debora-mirabal.46ec2128.jpg";